import { useState, useEffect } from "react";
import axios from "../axiosConfig";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

const usePermissions = () => {
    const [permissions, setPermissions] = useState<string[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const response = await axios.get("/api/user/permissions");

                if (response.status === 200 && response.data) {
                    if (Array.isArray(response.data)) {
                        const permissionNames = response.data
                            .map((perm: { name?: string }) => perm?.name)
                            .filter((name: string | undefined): name is string => !!name);

                        setPermissions(permissionNames);
                    } else {
                        console.error("Unexpected permissions response format:", response.data);
                        setError("Invalid permissions response format.");
                    }
                } else {
                    console.error("Failed to fetch permissions: ", response.status);
                    setError(`Error: ${response.status}`);
                }
            } catch (err) {
                const error = err as AxiosError;

                if (error.response) {
                    if (error.response.status === 401) {
                        setError("Unauthorized: Please log in again.");
                        localStorage.removeItem("token");
                        navigate("/login");
                    } else if (error.response.status === 403) {
                        setError("Forbidden: You do not have permission.");
                    } else {
                        setError(`Error: ${error.response.status}`);
                    }
                } else {
                    setError("Network error: Unable to fetch permissions.");
                }

                console.error("Error fetching permissions: ", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPermissions();
    }, [navigate]);

    return { permissions, loading, error };
};

export default usePermissions;